export default function Arrow () 
{
    return (
        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.4999 1.37231L6.74457 7.12768L0.989198 1.37231" stroke="#77889F" stroke-width="2"/>
        </svg>
    )
}